import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const SearchBarStyled = styled.div`
  position: relative;
  margin-top: 2.15rem;
  margin-bottom: 1.43rem;
  width: 100%;
`;

export const ResultsDropdown = styled.div`
  position: absolute;
  bottom: 0;
  max-width: 440px;
  max-height: 420px;
  transform: translateY(100%);
  background: #fff;
  border: 1px solid #c0c0c0;
  padding: 0.72rem;
  z-index: 1000;
  overflow-y: auto;
`;

export const SearchLink = styled(Link)`
  display: block;
  position: relative;
  padding: 0.86rem;
  padding-right: 2rem;
  margin-bottom: 1.43rem;
  border: 1px solid #c0c0c0;
  background: #f5f5f5;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textDark};

  & > div {
    margin-bottom: 0.25rem;
  }

  svg {
    position: absolute;
    right: 0.86rem;
    top: 50%;
    transform: translateY(-50%);

    path {
      stroke: #000;
      stroke-width: 50;
    }
  }
`;

export const SearchLinkHead = styled.div`
  font-weight: 700;
  display: flex;
  justify-content: space-between;
`;
